export default {  
    SET_DLISTINTERNAL: (state, payload) => state.dListInternal = payload,
  }